<template>
	<dropdown :class='{wide: wideWindow, activeFilter: filtered, right_align: rightAlign, filter}' :text='name' v-model='val' @input='open'>
		<div class='loading-wrap' v-if='loading'>
			<i class='fa fa-spinner fa-spin' style='font-size:26px;'></i>
		</div>
		<input type="text" v-model='text' placeholder="Поиск..." style="margin-top: 5px; width:100%;"/>
		<li>
			<checkbox type='info' v-model='sel'>Выбрать всё</checkbox>
		</li>
		<!-- -->
		<li role="separator" class="divider"></li>
		<!-- -->
		<div style='overflow-y: auto; max-height: 400px' @scroll="listScrollHandler" v-if='items.length'>
			<li v-for='i in items' :key='i.rank'>
				<checkbox type='info' v-model='i.checked' @input='e => checkboxInput(e, i.rank)'>
					<span v-html='i.show_value ? i.show_value : i.value' :class='{colored: (text && text.length)}'></span>
				</checkbox>
			</li>
		</div>
		<div v-if='!loading && !items.length'>
			Нет результатов для отображения
		</div>
		<!-- -->
		<li role="separator" class="divider"></li>
		<!-- -->
		<li class='pull-right'>
			<input type="button" class='btn btn-primary' value='Ок' @click='ok'/>
			<input type="button" class='btn btn-default' value='Отмена' @click='cancel'/>
		</li>
	</dropdown>
</template>

<script>
	import { dropdown, checkbox } from 'vue-strap'
	import { EventBus } from '../lib/EventBus'
	import {DB} from '../constants'
	import moment from 'moment'

	const FILTER = 'get_filter.php'
	const LIST_OFFSET = 20

	export default {
		name: 'Filter',
		data () {
			return {
				all_items: [],
				items: [],
				offset: 0,
				sel: true,
				val: false,
				filtered: false,
				saved_items: [],
				loading: false,
				text: '',
				scrollDebounce: false,
				FILTER: null,
				flag: false
			}
		},
		props: [
			'name',
			'field',
			'filter',
			'suffix',
			'wideWindow',
			'rightAlign',
			'year'
		],
		components: {
			dropdown,
			checkbox
		},
		watch: {
			sel (e) {
				this.all_items.map(t => {
					t.checked = e
				})
			},
			text (s) {
				if(s && s.length)
				{
					this.items = []
					for(let line of this.all_items)
					{
						const needle = s.toLowerCase()
						if(line.value.toLowerCase().indexOf(needle) !== -1)
						{
							let temp_line = line
							const regexp = new RegExp(`(${needle})`,"i")
							temp_line.show_value = temp_line.value.replace(regexp, '<span class="needle">$1</span>')
							this.items.push(temp_line)
						}
					}
					this.setCheckedToItems()		
				} else {
					this.items = this.all_items.slice(0, this.offset)
				}
				this.$forceUpdate()
			}
		},
		methods: {
			checkboxInput (value, rank) {
				//console.warn(value, rank)
				//const
				//for(let i in this.all_items)
				//	if(this.all_items[i].dense_rank == rank)

				//console.warn(value, rank)

				this.all_items[+rank].checked = value

				const result = []
				for(let item of this.all_items) {
					if(item.checked)
						result.push(item.value)
				}

				this.filtered = (result.length !== this.all_items.length) && (result.length !== 0)
				//EventBus.$emit('filter' + (this.suffix ? this.suffix : ''), {field: this.field, value: this.filtered ? result : [], filtered: this.filtered})
				
				//console.warn(this.all_items[81])
			},
			setCheckedToItems () {
				for (let i = 0; i < this.items.length; i++) {
					//if (typeof this.$parent.$parent.selected_filters[this.field + (this.suffix ? this.suffix : '')] !== 'undefined') {
						/*this.sel = false
						this.items[i].checked = false
						let flag = false
						for (let j = 0; j < this.$parent.$parent.selected_filters[this.field + (this.suffix ? this.suffix : '')].value.length; j++) {
							if (this.items[i].value === this.$parent.$parent.selected_filters[this.field + (this.suffix ? this.suffix : '')].value[j]) {
								this.items[i].checked = true
								flag = true
							}
							else if (!flag) {
								this.items[i].checked = false
								flag = false
							}
						}*/
					// else {
					//	const rank = this.items[i].rank
					//	this.items[i].checked = this.sel ? true : this.all_items[+rank].checked
					//}
				}
			},
			listScrollHandler (e) {
				if(this.text)
					return false

				if(this.scrollDebounce) {
					setTimeout(() => {
						this.scrollDebounce = false
						this.listScrollHandler(e)
					}, 500)
					return false
				}
					
				if(e.target.scrollTop + e.target.clientHeight + 100 >= e.target.scrollHeight && this.offset < this.all_items.length) {
					this.scrollDebounce = true
					setTimeout(() => this.scrollDebounce = false, 500)

					this.offset += LIST_OFFSET
					this.items = this.all_items.slice(0, this.offset)
					this.setCheckedToItems()
				}
			},
			ok () {
				this.val = false
				this.text = ''
				let result = []

				for(let item of this.all_items) {
					if(item.checked)
						result.push(item.value)
				}

				this.filtered = (result.length !== this.all_items.length) && (result.length !== 0)

				EventBus.$emit('filter' + (this.suffix ? this.suffix : ''), {field: this.field, value: this.filtered ? result : [], filtered: this.filtered})
				EventBus.$emit('filter' + (this.suffix ? this.suffix : '') + '_list', {field: this.field, value: this.filtered ? result : [], filtered: this.filtered})
			},
			cancel () {
				this.val = false
			},
			open (show) {
				if (show) {
					this.loading = true
					let where = '('
					for (let f in this.filter) {
						let field_name = f
						field_name = field_name.replace(this.suffix, '') 

						if(field_name == 'conclusion_date' || field_name == 'act_placement_date') {
							if(this.filter[f].length == 2) {
								const from = this.filter[f][0]
								const to = this.filter[f][1]
								where += `${field_name} BETWEEN '${from}' AND '${to}'  or `	
							}
						} else {
							for (let i = 0; i < this.filter[f].length; i++) {
								if (field_name !== this.field)
									where += `${field_name} = '${this.filter[f][i]}' or `
							}
						}
						if (field_name !== this.field) {
							where = this.filter[f].length !== 0 ? where.slice(0,-4) : where
							where += this.filter[f].length !== 0 ? ') and (' : ''
						}
					}
					where = where.slice(0,-6)
					if(where && where.length) {
						if(this.year) {
							where += ' and '
							where += `(act_placement_date BETWEEN '${this.year}-01-01' AND '${this.year}-12-31')`
						}
					}

					let field_name = this.field
					if(this.suffix)
						field_name = field_name.replace(this.suffix, '')

					if (typeof this.$parent.$parent.selected_filters[this.field + (this.suffix ? this.suffix : '')] == 'undefined')
						this.sel = true
					else
						this.sel = false

					fetch(DB + this.FILTER + '?field=' + field_name + '&filter=' + where)
					.then(res => res.json())
					.then(res => {
						if (res) {
							let arr = res.map((r,i) => {
								return {
									value: r[field_name] ? (field_name !== 'act_placement_date' && field_name !== 'conclusion_date' ? r[field_name] : moment(r[field_name], 'YYYY-MM-DD').format('DD.MM.YYYY')) : '',
									checked: this.sel,
									rank: r.dense_rank,
									show_value: ''
								}
							})

						//console.warn(this.$parent.$parent.selected_filters)

						this.all_items = arr
						//debugger;
						if (typeof this.$parent.$parent.selected_filters[this.field + (this.suffix ? this.suffix : '')] !== 'undefined') {
							//this.sel = false
							
							const saved_filter = this.$parent.$parent.selected_filters[this.field + (this.suffix ? this.suffix : '')].value

							for (let i = 0; i < this.all_items.length; i++) {
								if(saved_filter.includes(this.all_items[i].value))
									this.all_items[i].checked = true
								else
									this.all_items[i].checked = false
							}
						}
						//console.warn(this.all_items)

							/*for (let i = 0; i < arr.length; i++) {
								for (let j = 0; j < this.all_items.length; j++) {
									if (arr[i].value === this.all_items[j].value) {
										arr[i].checked = this.all_items[j].checked
									}
								}
							}*/						
							
						}
						else {
							this.all_items = []
						}
						this.text = ''					
						this.offset = LIST_OFFSET
						this.items = this.all_items.slice(0, this.offset)
						this.setCheckedToItems()
						this.loading = false
					})
					.catch(err => console.log(err))
				}
			},
			fill () {
				fetch(DB + this.FILTER + '?field=' + this.field + '&filter=')
				.then(res => res.json())
				.then(res => {
					if (res) {
						let arr = res.map(r => {
							return {
								value: r[this.field] ? (this.field !== 'act_placement_date' ? r[this.field] : moment(r[this.field], 'YYYY-MM-DD').format('DD.MM.YYYY')) : '',
								checked: true
							}
						})
						this.all_items = arr
					}
					else {
						this.all_items = []
					}
				})
				.catch(err => console.log(err))
			}
		},
		created () {
			if (typeof this.$parent.$parent.selected_filters[this.field + (this.suffix ? this.suffix : '')] !== 'undefined') {
				this.filtered = this.$parent.$parent.selected_filters[this.field + (this.suffix ? this.suffix : '')].filtered
			}
			else {
				this.saved_items = []
			}

			EventBus.$on('clearFilters' + (this.suffix ? this.suffix : ''), f => {
				this.filtered = false
				this.sel = true
				this.all_items = []
				this.fill()
				EventBus.$emit('filter' + (this.suffix ? this.suffix : ''), {field: this.field, value: [], filtered: false, cf: true})
				EventBus.$emit('filter' + (this.suffix ? this.suffix : '') + '_list', {field: this.field, value: [], filtered: false, cf: true})
			})
		},
		mounted () {
			this.FILTER = 'get_filter' + (this.suffix ? this.suffix : '') + '.php'
		},
		beforeDestroy () {
			EventBus.$off('clearFilters'+ (this.suffix ? this.suffix : ''))
		}
	}

</script>

<style>
	.activeFilter, .activeFilter > .dropdown-toggle {
		background-color: lightgreen !important;
		/*color: white;*/
	}

	div.filter, button.dropdown-toggle {
		width: 100%;
		/*height: 40%;*/
		padding-top: 0px;
		padding-bottom: 0px;
	}

	button.dropdown-toggle {
	 	font-weight: bold; 
		border: none;
	}

	ul.dropdown-menu {
		padding-left: 10px;
		padding-right: 10px;
		/*max-height: 500px;*/
		min-width: 200px;
		/*overflow-y: auto;*/
	}

	.loading-wrap {
		position: absolute;
	    left: 0;
	    right: 0;
	    z-index: 1000;
	    top: 0;
	    bottom: 49px;
	    background: rgba(255,255,255,0.8);
	    display: flex;
    	align-items: center;
    	justify-content: center;
	} 

	.wide > .dropdown-menu {
		min-width: 320px;
	}

	.right_align > .dropdown-menu {
		right: 0;
    	left: unset;
	}

	.colored {
		color: #888;
	}

	.needle {
		color: #000;
	}
</style>


// WEBPACK FOOTER //
// Filter.vue?22f59622